import React, {useState} from "react";
import ReactTable from "../../../components/ReactTableWrapper";

import connection from "../../../connection";
import Connection from "../../../connection";
import general from "../../../general";
import withStyles from "@material-ui/core/styles/withStyles";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Button from "components/CustomButtons/Button.jsx";

import SweetAlert from "../../../components/SweetAlertWrapper";

import formacoesStyle from "assets/jss/material-dashboard-pro-react/views/formacoesStyle";
import Add from "@material-ui/icons/Add";
import Refresh from "@material-ui/icons/Refresh";
import UserSearch from "../../../components/UserSearch";
import UserDetailsBox from "../../../components/UserDetailsBox";
import RegistrationState from "../../../components/RegistrationState";
import Datetime from "../../../components/DatetimeWrapper";
import Create from "@material-ui/icons/Create";
import CustomInput from "../../../components/CustomInput/CustomInput";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "../../../../node_modules/@material-ui/icons/Check";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Accordion from "../../../components/Accordion/Accordion";
import StateCircle from "../../../components/StateCircle";
import {GoogleMap, Marker, withGoogleMap, withScriptjs} from "react-google-maps";
import SnackbarContent from "../../../components/Snackbar/SnackbarContent";
import MomentFromNow from "../../../components/MomentFromNow";
import Table from "../../../components/Table/Table";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan, faCoins, faExclamationTriangle, faFileDownload, faFileExcel, faGraduationCap, faSearchPlus, faSpinner, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {convertToRaw, EditorState} from "draft-js";
import draftToHtml from "draftjs-to-html";
import {Editor} from "react-draft-wysiwyg";
import Parser from "html-react-parser";
import Tooltip from "@material-ui/core/Tooltip";
import {faCheckCircle} from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import {Close} from "@material-ui/icons";
import Person from "@material-ui/icons/Person";
import List from "@material-ui/icons/List";
import RateReview from "@material-ui/icons/RateReview";
import Attachment from "@material-ui/icons/Attachment";
import NavPills from "../../../components/NavPills/NavPills";
import Switch from "@material-ui/core/Switch";
import {Chip, Slider, Table as MaterialTable, TableBody, TableCell, TableHead, TableRow, TextField,} from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import {primaryColor, warningColor} from "../../../assets/jss/material-dashboard-pro-react";
import {HorizontalBar} from "react-chartjs-2";
import {fases} from "./fases";
import EquipaFormacao from "../../../components/EquipaFormacao";
import BotaoOpcoes from "../../../components/BotaoOpcoes";
import {DropzoneAreaBase} from 'material-ui-dropzone';
import modeloParticipantes from "../../../assets/static/MODELO_IMPORTACAO_PARTICIPANTES.xlsx";
import AnexoAcontecimento from "../../../components/AnexoAcontecimento/AnexoAcontecimento";
import EstadoUtilizador from "../../../components/EstadoUtilizador";

const FormacaoMap = withScriptjs(
  withGoogleMap(props => {
    return <GoogleMap
      defaultZoom={16}
      defaultCenter={{lat: props.lat, lng: props.lon}}
      defaultOptions={{
        disableDefaultUI: true
      }}
      center={{lat: props.lat, lng: props.lon}}
    >
      <Marker position={{lat: props.lat, lng: props.lon}}/>
    </GoogleMap>
  })
);


class GestaoFormacao extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formacao: props.detalhes,
      participantes: {},
      modal: null
    };

    this.hideModal = this.hideModal.bind(this);
    this.fecharFormacao = this.fecharFormacao.bind(this);
    this.inscreverFormando = this.inscreverFormando.bind(this);
    this.importarFormandosExcel = this.importarFormandosExcel.bind(this);

    this.reloadParticipantesFormacao = async () => {
      let participantes = await connection.get("formacao/participantes/listagem", {id_formacao: this.state.formacao.id});

      this.setState({
        participantes: participantes,
        participantes_avaliar: participantes.participantes.filter(p => p.acoes_utilizador.map(a => a.action).includes("FORMACAO_MARCAR_PRESENCA_AVALIAR")),
        participantes_editar_avaliacao: participantes.participantes.filter(p => p.acoes_utilizador.map(a => a.action).includes("EDITAR_AVALIACAO")),
        modal: null
      })
    };

    this.reloadPostsFormacao = async () => {
      let posts = await connection.get("formacao/post/listagem", {id_formacao: this.state.formacao.id});

      this.setState({
        posts,
        modal: null
      })
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {formacao: props.detalhes};
  }

  componentDidMount() {
    this.reloadParticipantesFormacao();
    this.reloadPostsFormacao();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.detalhes.id !== prevProps.detalhes.id) {
      this.reloadParticipantesFormacao();
      this.reloadPostsFormacao();
    }
  }

  hideModal() {
    this.setState({
      modal: null
    })
  }

  inscreverFormando(recurso = false) {
    const {classes} = this.props;

    let formando = null;
    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Inscrever Formando no Módulo</span>
        </div>)}
        onConfirm={() => {
          connection.post("formacao/participante/inscrever" + (recurso ? "_recurso" : ""), {formacao: this.state.formacao.id, formando: formando}, (data) => {
            this.reloadParticipantesFormacao();
            general.success("Formando inscrito com sucesso.", "Sucesso!");
          });
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Inscrever"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        {this.avisoInscricaoNumerario()}
        <form autoComplete="off" className={classes.addForm}>
          <UserSearch
            labelText="NIN do Formando"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0"
            }}
            onFoundUser={(user) => {
              formando = user.NIN
            }}
          />
        </form>
      </SweetAlert>)
    });
  }

  avisoInscricaoNumerario() {
    const {classes} = this.props;

    return this.state.formacao.estado.code >= general.estadosAcontecimento.A_DECORRER && this.state.formacao.estado.code < general.estadosAcontecimento.FECHADO
      && <div className={classes.warningLabel} style={{marginTop: 0, marginBottom: 10, padding: "15px 15px"}}>
        <span className="">O módulo já está iniciou ou já terminou, pelo que esta participação será considerada paga em numerário</span>
      </div>;
  }

  importarFormandosExcel(recurso = false) {
    const {classes} = this.props;

    let Modal = () => {
      const [ficheiro, setFicheiro] = useState(null);
      const [previsao, setPrevisao] = useState(null);
      const [aguardar, setAguardar] = useState(false);

      let dadosImportacao = (ficheiro_escolhido) => {
        let form_data = new FormData();
        form_data.append("excel", ficheiro_escolhido.file);
        form_data.append("formacao", this.state.formacao.id);
        form_data.append("recurso", recurso);
        return form_data;
      };

      // Assim que o ficheiro entra é pedida ao servidor uma simulação da importação (que faz
      // rollback no fim), para se saber quem vai mesmo ser inscrito antes de confirmar
      let analisar = async (novo_ficheiro) => {
        setFicheiro(novo_ficheiro);
        setPrevisao(null);

        if (!novo_ficheiro)
          return;

        setAguardar(true);
        try {
          setPrevisao(await connection.post("formacao/participantes/importar?simulacao=1", dadosImportacao(novo_ficheiro), null, null, {returnError: true}));
        } catch (e) {
          setFicheiro(null);
        }
        setAguardar(false);
      };

      let pode_importar = previsao?.inscritos > 0;

      return <SweetAlert
        style={{width: 800}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Inscrever Formandos no Módulo</span>
        </div>)}
        onConfirm={async () => {
          if (!pode_importar)
            return;

          await connection.post("formacao/participantes/importar", dadosImportacao(ficheiro), null, null, {returnError: true});
          this.hideModal();
          this.reloadParticipantesFormacao();
          general.success(previsao.inscritos === 1 ? "Foi inscrito 1 formando" : "Foram inscritos " + previsao.inscritos + " formandos", "Sucesso!");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Importar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm + (pode_importar ? "" : " " + classes.disabled)
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        {this.avisoInscricaoNumerario()}
        <form autoComplete="off" className={classes.addForm}>
          <p style={{margin: "20px 0"}}>
            O ficheiro deve ter uma coluna <strong>NIN</strong> com o número de identificação de cada formando a inscrever.
            <a href={modeloParticipantes} style={{float: "right", cursor: "pointer"}}>
              <small><FontAwesomeIcon icon={faFileDownload}/> Descarregar exemplo</small>
            </a>
          </p>
          {!ficheiro && <DropzoneAreaBase
            acceptedFiles={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
            filesLimit={1}
            fileObjects={[]}
            onAdd={(ficheiros) => analisar(ficheiros[0])}
            dropzoneText={"Arraste para aqui o ficheiro Excel com os formandos a inscrever"}
            dropzoneClass={classes.dropzoneImportacao}
            showAlerts={false}
          />}
          {aguardar && <p style={{margin: "20px 0", textAlign: "center"}}>
            <FontAwesomeIcon icon={faSpinner} spin/> A validar as inscrições...
          </p>}
          {previsao && <div style={{maxHeight: "calc(100vh - 420px)", minHeight: 200, overflow: "auto"}}>
            <MaterialTable className={classes.table} size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>NIN</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell align="right">Nota importação</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {previsao.participantes.map((participante, i) => (
                  <TableRow key={i}>
                    <TableCell component="th" scope="row">{participante.nin || "-"}</TableCell>
                    <TableCell>{participante.nome || "-"}</TableCell>
                    <TableCell align="right">
                      {participante.inscrito ? "Vai ser inscrito" : <span style={{color: warningColor}}>{participante.nota}</span>}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </MaterialTable>
          </div>}
        </form>
      </SweetAlert>;
    };

    this.setState({modal: <Modal/>});
  }

  // Integração com o Moodle. Sem disciplina criada abre o popup de criação, alimentado pela
  // simulação (que não escreve nada, nem no Moodle nem na base de dados); com disciplina
  // criada abre o popup de estado, que só lê e mostra as divergências.
  gerirMoodle() {
    const {classes} = this.props;

    let Modal = () => {
      const [estado, setEstado] = useState(null);
      const [previsao, setPrevisao] = useState(null);
      const [referencia, setReferencia] = useState("");
      const [copiar, setCopiar] = useState(false);
      const [aguardar, setAguardar] = useState(true);
      const [acriar, setACriar] = useState(false);
      const [erro, setErro] = useState(null);

      // A simulação é a única fonte do resumo: categoria de destino, disciplina base
      // encontrada e quantas contas Moodle seriam criadas de novo
      let simular = async (base_referencia) => {
        setAguardar(true);
        setErro(null);
        try {
          setPrevisao(await connection.post("formacao/moodle/criar?simulacao=1", {
            formacao: this.state.formacao.id,
            base_referencia: base_referencia || undefined
          }, null, null, {returnError: true, disableNotif: true}));
        } catch (e) {
          setPrevisao(null);
          setErro(e?.message || "Não foi possível preparar a criação da disciplina.");
        }
        setAguardar(false);
      };

      let consultarEstado = async () => {
        try {
          let atual = await connection.get("formacao/moodle/estado", {formacao: this.state.formacao.id}, null, null, {returnError: true, disableNotif: true});
          setEstado(atual);
          return atual;
        } catch (e) {
          setErro(e?.message || "Não foi possível consultar o Moodle.");
          return null;
        }
      };

      React.useEffect(() => {
        (async () => {
          let atual = await consultarEstado();
          if (!atual || atual.id_moodle)
            setAguardar(false);
          else
            await simular(null);
        })();
      }, []);

      // Enquanto a cópia de conteúdos está em fila o popup volta a perguntar, para a rodinha
      // desaparecer sozinha quando o cron acabar
      React.useEffect(() => {
        if (estado?.importacao?.estado !== "pendente")
          return;
        let temporizador = setInterval(consultarEstado, 15000);
        return () => clearInterval(temporizador);
      }, [estado?.importacao?.estado]);

      let titulo = (texto) => (<div style={{textAlign: "left", marginTop: "-20px"}}>
        <span className={classes.modalCardTitle}>{texto}</span>
      </div>);

      let aviso = erro && <div className={classes.warningLabel} style={{marginTop: 0, marginBottom: 10, padding: "15px 15px"}}>
        <span><FontAwesomeIcon icon={faExclamationTriangle}/> {erro}</span>
      </div>;

      // Disciplina já criada: popup de estado
      if (estado?.id_moodle) {
        let divergencias = estado.divergencias || {};
        let sincronizado = !divergencias.a_inscrever?.length && !divergencias.a_remover?.length && !divergencias.sem_conta?.length;

        return <SweetAlert
          style={{width: 520}}
          title={titulo("Disciplina no Moodle")}
          onConfirm={() => {
            window.open(estado.url, "_blank", "noopener");
            this.hideModal();
          }}
          confirmBtnText="Abrir Moodle"
          confirmBtnCssClass={classes.button + " " + classes.primary + " " + classes.buttonConfirm}
          onCancel={() => this.hideModal()}
          cancelBtnText="Fechar"
          cancelBtnCssClass={classes.button}
          showCancel
        >
          <div className={classes.addForm} style={{textAlign: "left"}}>
            <p style={{margin: "10px 0"}}>
              <strong>{estado.disciplina?.fullname}</strong><br/>
              <a href={estado.url} target="_blank" rel="noopener noreferrer">{estado.url}</a>
            </p>
            <p style={{margin: "10px 0"}}>Categoria: {estado.categoria?.caminho || "-"}</p>
            {estado.email_ocupado?.length > 0 && <div style={{margin: "10px 0", color: warningColor}}>
              <strong>Não é possível criar conta no Moodle</strong> (os secretários regionais destes utilizadores serão notificados):
              <ul style={{margin: "4px 0 0", paddingLeft: 20}}>
                {estado.email_ocupado.map((p, i) => <li key={i}>{p.nin} - {p.nome} ({p.motivo})</li>)}
              </ul>
            </div>}
            {estado.metadados_moodle?.base?.valor && <p style={{margin: "10px 0"}}>
              {estado.importacao?.estado === "pendente"
                ? <span><FontAwesomeIcon icon={faSpinner} spin/> A copiar conteúdos{estado.metadados_moodle.base.nome ? <> de <strong>{estado.metadados_moodle.base.nome}</strong></> : null}...</span>
                : estado.importacao?.estado === "erro"
                  ? <span style={{color: warningColor}}><FontAwesomeIcon icon={faExclamationTriangle}/> Não foi possível copiar os conteúdos{estado.metadados_moodle.base.nome ? <> de <strong>{estado.metadados_moodle.base.nome}</strong></> : null}: {estado.importacao.erro || "erro desconhecido"}</span>
                  : <span>Conteúdos copiados{estado.metadados_moodle.base.nome ? <> de <strong>{estado.metadados_moodle.base.nome}</strong></> : null}</span>}
            </p>}
            {sincronizado
              ? <p style={{margin: "10px 0"}}><FontAwesomeIcon icon={faCheckCircle}/> Não há divergências: as inscrições estão sincronizadas.</p>
              : <div style={{maxHeight: "calc(100vh - 460px)", minHeight: 100, overflow: "auto"}}>
                <MaterialTable className={classes.table} size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>NIN</TableCell>
                      <TableCell>Nome</TableCell>
                      <TableCell align="right">Divergência</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[
                      ...(divergencias.a_inscrever || []).map(p => ({...p, nota: "Vai ser inscrito"})),
                      ...(divergencias.a_remover || []).map(p => ({...p, nota: "Vai sair da disciplina"})),
                      ...(divergencias.sem_conta || []).map(p => ({...p, nota: "Sem conta no Moodle"}))
                    ].map((pessoa, i) => (
                      <TableRow key={i}>
                        <TableCell component="th" scope="row">{pessoa.nin || "-"}</TableCell>
                        <TableCell>{pessoa.nome || "-"}</TableCell>
                        <TableCell align="right"><span style={{color: warningColor}}>{pessoa.nota}</span></TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </MaterialTable>
                <p style={{margin: "10px 0"}}><small>As divergências são corrigidas automaticamente na próxima sincronização.</small></p>
              </div>}
          </div>
        </SweetAlert>;
      }

      // O toggle da disciplina base só existe quando o módulo não a tem definida: quando tem,
      // é essa que manda e não há nada a escolher
      // Associar a uma disciplina que já existe nunca copia conteúdos, por isso a opção desaparece
      let pode_escolher_base = estado && !estado.base_definida && !previsao?.associada;
      let pode_criar = !!previsao && !aguardar;

      return <SweetAlert
        style={{width: 520}}
        title={titulo("Criar disciplina no Moodle")}
        onConfirm={async () => {
          if (!pode_criar || acriar)
            return;

          // A criação é síncrona (categoria, disciplina e inscrições) e pode demorar alguns
          // segundos: o botão fica bloqueado para não haver duas criações do mesmo acontecimento
          setACriar(true);

          let resultado = await connection.post("formacao/moodle/criar", {
            formacao: this.state.formacao.id,
            base_referencia: copiar && referencia ? referencia : undefined
          }, null, null, {returnError: true});

          this.hideModal();
          this.props.reloadDetalhes();
          general.success(resultado.associada
            ? "Associado à disciplina " + resultado.disciplina.shortname + ", que já existia no Moodle."
            : "Disciplina criada no Moodle: " + resultado.disciplina.shortname
            + (resultado.importacao ? ". A sincronização de participantes e conteúdos será processada em breve." : ""), "Sucesso!");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText={acriar ? <><FontAwesomeIcon icon={faSpinner} spin/> A criar...</> : "Criar"}
        confirmBtnCssClass={classes.button + " " + classes.primary + " " + classes.buttonConfirm + (pode_criar && !acriar ? "" : " " + classes.disabled)}
        cancelBtnCssClass={classes.button}
      >
        {aviso}
        <form autoComplete="off" className={classes.addForm}>
          {aguardar && <p style={{margin: "20px 0", textAlign: "center"}}>
            <FontAwesomeIcon icon={faSpinner} spin/> A carregar informação do Moodle...
          </p>}
          {previsao && <div style={{textAlign: "left"}}>
            {previsao.associada && <div className={classes.warningLabel} style={{marginTop: 0, marginBottom: 20, padding: "12px 15px", fontSize: 13}}>
              <span><FontAwesomeIcon icon={faExclamationTriangle}/> Já existe uma disciplina criada no Moodle para este curso. A disciplina será associada à Cordilheira e os participantes serão sincronizados.</span>
            </div>}
            <p style={{margin: "10px 0"}}>
              Nome disciplina: <strong>{previsao.disciplina.fullname}</strong>
            </p>
            <p style={{margin: "10px 0"}}>
              Categoria: <strong>{previsao.categoria.caminho}</strong>
            </p>
            <p style={{margin: "10px 0"}}>
              Elementos a inscrever: <strong>{previsao.participantes + previsao.equipa}</strong>
            </p>
            {[
              {lista: previsao.sem_email, titulo: "Sem email na Cordilheira, não é possível criar conta"},
              {lista: previsao.inativos, titulo: "Inativos no SIIE, não são inscritos"},
              {
                lista: previsao.email_ocupado,
                titulo: "Não é possível criar conta no Moodle",
                detalhe: "(os secretários regionais destes utilizadores serão notificados)"
              }
            ].filter(bloco => bloco.lista?.length > 0).map((bloco, i) => <div key={i} style={{margin: "10px 0", color: warningColor}}>
              <strong>{bloco.titulo}</strong>{bloco.detalhe ? " " + bloco.detalhe : ""}:
              <ul style={{margin: "4px 0 0", paddingLeft: 20}}>
                {bloco.lista.map((p, j) => <li key={j}>{p.nin} - {p.nome}{(p.motivo || p.estado) ? " (" + (p.motivo || p.estado) + ")" : ""}</li>)}
              </ul>
            </div>)}
            {previsao.base && !pode_escolher_base && <p style={{margin: "10px 0"}}>
              Os conteúdos são copiados da disciplina definida no módulo: <strong>{previsao.base.disciplina?.fullname}</strong>
            </p>}
          </div>}
          {pode_escolher_base && <div style={{textAlign: "left", marginTop: 15}}>
            <FormControlLabel
              className={classes.switchMoodle}
              control={<Switch checked={copiar} onChange={(e) => {
                setCopiar(e.target.checked);
                if (!e.target.checked)
                  simular(null);
              }}/>}
              label="Copiar conteúdos de outra disciplina"
            />
            {copiar && <div style={{display: "flex", alignItems: "flex-end", gap: 10}}>
              <CustomInput
                labelText="Endereço da disciplina ou referência (ex.: #00342)"
                formControlProps={{fullWidth: true}}
                inputProps={{
                  value: referencia,
                  onChange: (e) => setReferencia(e.target.value)
                }}
              />
              <Button
                className={classes.button}
                disabled={aguardar || !referencia}
                onClick={() => simular(referencia)}
              >Validar</Button>
            </div>}
            {copiar && previsao?.base?.disciplina && <p style={{margin: "10px 0"}}>
              <FontAwesomeIcon icon={faCheckCircle}/> Disciplina encontrada: <strong>{previsao.base.disciplina.fullname}</strong>
            </p>}
          </div>}
        </form>
      </SweetAlert>;
    };

    this.setState({modal: <Modal/>});
  }

  fecharFormacao() {
    const {location} = this.props;
    let curso_id = location.pathname.split("/formacao/")[1];
    this.setState({
      modal: (<SweetAlert
        warning
        title="Fechar Formacao"
        onConfirm={() => {
          connection.post("formacao/fechar", {id_curso: curso_id}, (data) => {
            if (data.success) {
              this.hideModal();
              this.props.reloadDetalhes();
              general.success("Formacao fechado com sucesso.", "Sucesso!");
            } else {
              general.error("Por favor tente novamente mais tarde.", "Erro!")
            }
          })
        }}
        onCancel={() => this.hideModal()}
        confirmBtnCssClass={
          this.props.classes.button + " " + this.props.classes.danger
        }
        cancelBtnCssClass={
          this.props.classes.button
        }
        confirmBtnText="Fechar Formacao"
        cancelBtnText="Cancelar"
        showCancel
      >
        Atenção! Ao fechar este formacao, todos os formandos que não tenham obtido aprovação serão automaticamente reprovados.
      </SweetAlert>)
    })
  }

  editDetalhesFormacao = async () => {
    const {classes} = this.props;

    let regioes = await connection.get("regiao/listagem");
    let nucleos = await connection.get("nucleo/listagem");
    let agrupamentos = await connection.get("agrupamento/listagem");

    if (!regioes.find((reg) => reg.id === this.state.formacao.id_regiao))
      regioes.unshift({id: this.state.formacao.id_regiao || 0, designacao: this.state.formacao.regiao || 'Nenhuma'});
    if (!nucleos.find((nuc) => nuc.id === this.state.formacao.id_nucleo))
      nucleos.unshift({id: this.state.formacao.id_nucleo || 0, designacao: this.state.formacao.nucleo || 'Nenhum', regiao: null});
    if (!agrupamentos.find((ag) => ag.id === this.state.formacao.id_agrupamento))
      agrupamentos.unshift({id: this.state.formacao.id_agrupamento || 0, designacao: this.state.formacao.agrupamento || 'Nenhum', nucleo: null});

    let formacao = {
      agrupamento: this.state.formacao.id_agrupamento || 0,
      nucleo: this.state.formacao.id_nucleo || 0,
      regiao: this.state.formacao.id_regiao || 0,
      formador: this.state.formacao.formador
    };

    let Content = () => {
      const [curso_agrupamento_state, setAgrupamentoState] = useState(formacao.agrupamento);
      const [curso_nucleo_state, setNucleoState] = useState(formacao.nucleo);
      const [curso_regiao_state, setRegiaoState] = useState(formacao.regiao);

      let nucleo_ativo = nucleos.find((nucleo) => nucleo.id === curso_nucleo_state);
      let regiao_ativa = regioes.find((regiao) => regiao.id === curso_regiao_state);

      return <form autoComplete="off" className={classes.addForm}>
        <UserSearch
          labelText="Formador"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            type: "number",
            min: "0"
          }}
          defaultUser={formacao.formador}
          onFoundUser={(user) => {
            formacao.formador = user
          }}
        />
        {general.userHasType("admin", "chefe_nacional") && <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Região
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={curso_regiao_state}
            onChange={(event) => {
              if (formacao.regiao === event.target.value)
                return;
              formacao.nucleo = null;
              setNucleoState(null);
              formacao.agrupamento = null;
              setAgrupamentoState(null);
              formacao.regiao = event.target.value;
              setRegiaoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a região</MenuItem>
            {this.state.formacao.regiao && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhuma</MenuItem>}
            {regioes.map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>}
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Núcleo
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={curso_nucleo_state}
            onChange={(event) => {
              if (formacao.nucleo === event.target.value)
                return;
              formacao.agrupamento = null;
              setAgrupamentoState(null);
              formacao.nucleo = event.target.value;
              setNucleoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha o núcleo</MenuItem>
            {this.state.formacao.nucleo && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhum</MenuItem>}
            {nucleos.filter(nucleo => regiao_ativa && nucleo.regiao === regiao_ativa.codigo || nucleo.id === 0).map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}</MenuItem>;
            })}
          </Select>
        </FormControl>
        <FormControl fullWidth className={classes.selectFormControl}>
          <InputLabel className={classes.selectLabel}>
            Agrupamento
          </InputLabel>
          <Select
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            value={curso_agrupamento_state}
            onChange={(event) => {
              if (formacao.agrupamento === event.target.value)
                return;
              formacao.agrupamento = event.target.value;
              setAgrupamentoState(event.target.value);
            }}
          >
            <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha o agrupamento</MenuItem>
            {this.state.formacao.agrupamento && <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={0}>Nenhum</MenuItem>}
            {agrupamentos.filter(agrupamento => nucleo_ativo && agrupamento.nucleo === nucleo_ativo.codigo || agrupamento.id === 0).map((item) => {
              return <MenuItem key={Math.random()} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.id}>{item.designacao}{item.codigo && <span> ({item.codigo})</span>}</MenuItem>;
            })}
          </Select>
        </FormControl>
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Detalhes</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("formacao/editar_detalhes", {
            formacao: this.state.formacao.id,
            agrupamento: formacao.agrupamento || null,
            nucleo: formacao.nucleo || null,
            regiao: formacao.regiao || null,
            formador: formacao.formador.NIN
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Formação editada", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  promptModal = (designacao, instrucoes, valor, callback) => {
    const {classes} = this.props;

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar {designacao}</span>
        </div>)}
        onConfirm={() => callback(valor)}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <p>{instrucoes}</p>
          <CustomInput
            formControlProps={{
              fullWidth: true,
              style: {padding: 0, margin: 0}
            }}
            inputProps={{
              type: "text",
              multiline: true,
              defaultValue: valor,
              placeholder: "Escrever " + designacao.toLowerCase(),
              rows: 3,
              onChange: (e) => {
                valor = e.target.value
              }
            }}
          />
        </form>
      </SweetAlert>)
    });
  };

  anularFormacao = async () => {
    const {classes} = this.props;
    const formacao = this.state.formacao;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Anular Formação"}
        onConfirm={async () => {
          await connection.post("formacao/anular", {formacao: formacao.id});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesFormacao();
          general.success("Formação anulada com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Confirmar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 5}}>Tem a certeza que pretende anular a formação #{formacao.id} - {formacao.modulo.area} | {formacao.modulo.designacao}?</p>
        <p style={{marginTop: 5}}>Uma vez anulada, todos os candidatos serão notificados de que não foram selecionados e a formação não poderá mais ser reaberta!</p>
      </SweetAlert>
    });
  }

  editPropriedadesFormacao = async () => {
    const {classes} = this.props;

    let modalidades = await connection.get("formacao/modalidades");

    // Remover modalidades desativadas, a menos que a opção esteja selecionada
    modalidades = modalidades.filter(m => !m.desativado || m.codigo === this.state.formacao.modalidade);

    let formacao = {
      data_abertura_registos: this.state.formacao.data_abertura_registos,
      data_limite_registos: this.state.formacao.data_limite_registos,
      data_inicio: this.state.formacao.data_inicio,
      data_fim: this.state.formacao.data_fim,
      vagas: this.state.formacao.vagas,
      preco: this.state.formacao.preco,
      preco_para_curso: this.state.formacao.preco_para_curso,
      modalidade: this.state.formacao.modalidade || modalidades[0]?.codigo,
      limite_inscricoes: this.state.formacao.limite_inscricoes,
      apenas_formadores: this.state.formacao.apenas_formadores,
      apenas_dirigentes: this.state.formacao.apenas_dirigentes,
      apenas_candidatos: this.state.formacao.apenas_candidatos,
      apenas_regiao: this.state.formacao.apenas_regiao
    };

    let gratuito = formacao.preco === 0;
    let gratuito_curso = formacao.preco_para_curso === 0;
    let limite_candidaturas = formacao.limite_inscricoes > 0;
    let apenas_formadores = !!formacao.apenas_formadores;
    let apenas_dirigentes = !!formacao.apenas_dirigentes;
    let apenas_candidatos = !!formacao.apenas_candidatos;
    let apenas_regiao = !!formacao.apenas_regiao;

    let pode_alterar_pagamento_ou_modalidade = !(this.state.formacao.referencias_geradas > 0) && !(this.state.formacao.participantes > 0);

    let Content = () => {
      const [curso_preco_gratuito_state, setGratuito] = useState(gratuito);
      const [curso_preco_gratuito_curso_state, setGratuitoCurso] = useState(gratuito_curso);
      const [modalidade_state, setModalidadeState] = useState(formacao.modalidade);
      const [formacao_limite_candidatura_state, setLimiteCandidaturas] = useState(limite_candidaturas);
      const [apenas_formadores_state, setApenasFormadores] = useState(apenas_formadores)
      const [apenas_dirigentes_state, setApenasDirigentes] = useState(apenas_dirigentes)
      const [apenas_candidatos_state, setApenasCandidatos] = useState(apenas_candidatos)
      const [apenas_regiao_state, setApenasRegiao] = useState(apenas_regiao)

      let pode_editar_modalidade = !this.state.formacao.curso || this.state.formacao.curso?.modalidade === 'BLEARNING';

      let input_modalidade = <FormControl fullWidth className={classes.selectFormControl + " " + (!pode_editar_modalidade ? classes.disabled : null)}>
        <InputLabel className={classes.selectLabel}>
          Modalidade
        </InputLabel>
        <Select
          MenuProps={{
            className: classes.selectMenu
          }}
          classes={{
            select: classes.select
          }}
          value={modalidade_state}
          onChange={(event) => {
            if (formacao.modalidade === event.target.value)
              return;
            formacao.modalidade = event.target.value;
            setModalidadeState(event.target.value);
          }}
        >
          <MenuItem disabled classes={{root: classes.selectMenuItem}}>Escolha a modalidade</MenuItem>
          {modalidades.map((item) => {
            return <MenuItem key={item.codigo} classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}} value={item.codigo}>{item.designacao}</MenuItem>;
          })}
        </Select>
      </FormControl>

      return <form autoComplete="off" className={classes.addForm}>
        {pode_editar_modalidade && pode_alterar_pagamento_ou_modalidade && input_modalidade}
        {!pode_editar_modalidade && pode_alterar_pagamento_ou_modalidade && <Tooltip title={`Este módulo faz parte de um curso ${this.state.formacao.curso?.modalidade_designacao.toLowerCase()} e também de ser ${this.state.formacao.curso?.modalidade_designacao.toLowerCase()}.`} placement="bottom">
          <div>{input_modalidade}</div>
        </Tooltip>}
        {!this.state.formacao.curso && <>
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Abertura de registos
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolha a data"}}
              onChange={(value) => {
                formacao.data_abertura_registos = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={"H:mm"}
              defaultValue={formacao.data_abertura_registos}
            />
          </FormControl>
          <FormControl fullWidth>
            <InputLabel shrink={true} className={classes.selectLabel}>
              Data-limite para registos
            </InputLabel>
            <Datetime
              inputProps={{placeholder: "Escolha a data"}}
              onChange={(value) => {
                formacao.data_limite_registos = value;
              }}
              dateFormat={"DD/MM/YYYY"}
              timeFormat={"H:mm"}
              defaultValue={formacao.data_limite_registos}
            />
          </FormControl>
        </>}
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Início do módulo
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              formacao.data_inicio = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={formacao.data_inicio}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel shrink={true} className={classes.selectLabel}>
            Fim do módulo
          </InputLabel>
          <Datetime
            inputProps={{placeholder: "Escolha a data"}}
            onChange={(value) => {
              formacao.data_fim = value;
            }}
            dateFormat={"DD/MM/YYYY"}
            timeFormat={"H:mm"}
            defaultValue={formacao.data_fim}
          />
        </FormControl>
        {!this.state.formacao.curso && <>
          <CustomInput
            labelText="Vagas"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "number",
              min: "0",
              defaultValue: formacao.vagas,
              onChange: (e) => {
                formacao.vagas = e.target.value
              }
            }}
          />
          {this.state.formacao.estado.code < general.estadosAcontecimento.REGISTOS_FINALIZADOS && <>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formacao_limite_candidatura_state}
                  tabIndex={-1}
                  onClick={() => {
                    limite_candidaturas = !formacao_limite_candidatura_state;
                    setLimiteCandidaturas(!formacao_limite_candidatura_state);
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Limite de candidaturas"}
            /><br/>
            {formacao_limite_candidatura_state && <CustomInput
              labelText="Limite de inscrições"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                type: "number",
                min: "0",
                step: 0.01,
                defaultValue: formacao.limite_inscricoes,
                onChange: (e) => {
                  formacao.limite_inscricoes = e.target.value
                }
              }}
            />}
            {pode_alterar_pagamento_ou_modalidade && <>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={curso_preco_gratuito_state}
                    tabIndex={-1}
                    onClick={() => {
                      gratuito = !curso_preco_gratuito_state;
                      setGratuito(!curso_preco_gratuito_state);
                    }}
                    checkedIcon={<Check className={classes.checkedIcon}/>}
                    icon={<Check className={classes.uncheckedIcon}/>}
                    classes={{
                      checked: classes.checked
                    }}
                  />
                }
                classes={{
                  label: classes.label
                }}
                label={"Gratuito"}
              /><br/>
              {!curso_preco_gratuito_state && <CustomInput
                labelText="Preço (€)"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={{
                  type: "number",
                  min: "0",
                  step: 0.01,
                  defaultValue: formacao.preco,
                  onChange: (e) => {
                    formacao.preco = e.target.value
                  }
                }}
              />}
            </>}
            <FormControlLabel
              control={
                <Checkbox
                  checked={apenas_formadores_state}
                  tabIndex={-1}
                  onClick={() => {
                    apenas_formadores = !apenas_formadores_state;
                    setApenasFormadores(!apenas_formadores_state);
                    apenas_dirigentes = false;
                    setApenasDirigentes(false);
                    apenas_candidatos = false;
                    setApenasCandidatos(false);
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Apenas para formadores e diretores de formação"}
            /><br/>
            <FormControlLabel
              control={
                <Checkbox
                  checked={apenas_dirigentes_state}
                  tabIndex={-1}
                  onClick={() => {
                    apenas_dirigentes = !apenas_dirigentes_state;
                    setApenasDirigentes(!apenas_dirigentes_state);
                    apenas_formadores = false;
                    setApenasFormadores(false);
                    apenas_candidatos = false;
                    setApenasCandidatos(false);
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Apenas para dirigentes"}
            /><br/>
            <FormControlLabel
              control={
                <Checkbox
                  checked={apenas_candidatos_state}
                  tabIndex={-1}
                  onClick={() => {
                    apenas_candidatos = !apenas_candidatos_state;
                    setApenasCandidatos(!apenas_candidatos_state);
                    apenas_dirigentes = false;
                    setApenasDirigentes(false);
                    apenas_formadores = false;
                    setApenasFormadores(false);
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Apenas para candidatos"}
            />
            <br/>
            <FormControlLabel
              control={
                <Checkbox
                  checked={apenas_regiao}
                  tabIndex={-1}
                  onClick={() => {
                    apenas_regiao = !apenas_regiao;
                    setApenasRegiao(!apenas_regiao_state);
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Apenas para a região"}
            />
            <br/>
          </>}
          {this.state.formacao.curso && <React.Fragment>
            <FormControlLabel
              control={
                <Checkbox
                  checked={curso_preco_gratuito_curso_state}
                  tabIndex={-1}
                  onClick={() => {
                    gratuito_curso = !curso_preco_gratuito_curso_state;
                    setGratuitoCurso(!curso_preco_gratuito_curso_state);
                  }}
                  checkedIcon={<Check className={classes.checkedIcon}/>}
                  icon={<Check className={classes.uncheckedIcon}/>}
                  classes={{
                    checked: classes.checked
                  }}
                />
              }
              classes={{
                label: classes.label
              }}
              label={"Gratuito para inscritos no curso"}
            />
            {!curso_preco_gratuito_curso_state && <CustomInput
              labelText="Preço para inscritos no curso (€)"
              formControlProps={{
                fullWidth: true
              }}
              inputProps={{
                type: "number",
                min: "0",
                step: 0.01,
                defaultValue: formacao.preco_para_curso,
                onChange: (e) => {
                  formacao.preco_para_curso = e.target.value
                }
              }}/>}
          </React.Fragment>}
          {this.state.formacao.pode_anular && <span style={{color: "red"}} className="clickable" onClick={() => {
            this.anularFormacao();
          }}><FontAwesomeIcon icon={faBan}/> Anular Formação</span>}
          <br/>
        </>}
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Informações</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("formacao/editar_informacoes", {
            formacao: this.state.formacao.id,
            modalidade: formacao.modalidade,
            data_abertura_registos: formacao.data_abertura_registos,
            data_limite_registos: formacao.data_limite_registos,
            data_inicio: formacao.data_inicio,
            data_fim: formacao.data_fim,
            vagas: formacao.vagas,
            preco: gratuito ? 0 : formacao.preco,
            preco_para_curso: gratuito_curso ? 0 : formacao.preco_para_curso,
            limite_inscricoes: limite_candidaturas ? formacao.limite_inscricoes : null,
            apenas_formadores: apenas_formadores,
            apenas_dirigentes: apenas_dirigentes,
            apenas_candidatos: apenas_candidatos,
            apenas_regiao: apenas_regiao,
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Formação editada", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <Content/>
      </SweetAlert>)
    });
  };

  editLocalFormacao = async () => {
    const {classes} = this.props;

    let formacao = {
      lat: this.state.formacao.lat,
      lon: this.state.formacao.lon,
      local: this.state.formacao.local
    };

    let Content = () => {

      return <form autoComplete="off" className={classes.addForm}>
        <CustomInput
          labelText="Local*"
          formControlProps={{
            fullWidth: true
          }}
          inputProps={{
            defaultValue: formacao.local,
            onChange: (e) => {
              formacao.local = e.target.value
            }
          }}
        />
        <CustomInput
          labelText="Latitude"
          formControlProps={{
            fullWidth: true
          }}
          labelProps={{
            shrink: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            step: '0.0000001',
            placeholder: '38,707778',
            defaultValue: formacao.lat,
            onChange: (e) => {
              formacao.lat = e.target.value
            }
          }}
        />
        <CustomInput
          labelText="Longitude"
          formControlProps={{
            fullWidth: true
          }}
          labelProps={{
            shrink: true
          }}
          inputProps={{
            type: "number",
            min: "0",
            step: '0.0000001',
            placeholder: '-9,151648',
            defaultValue: formacao.lon,
            onChange: (e) => {
              formacao.lon = e.target.value
            }
          }}
        />
      </form>
    };

    this.setState({
      modal: (<SweetAlert
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Editar Local</span>
        </div>)}
        onConfirm={async () => {
          await connection.post("formacao/editar_local", {
            formacao: this.state.formacao.id,
            lat: formacao.lat,
            lon: formacao.lon,
            designacao: formacao.local
          });
          this.hideModal();
          this.props.reloadDetalhes();
          general.success("Local editado", "Sucesso");
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Guardar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <div style={{margin: "10px 0px 30px"}}>
          <SnackbarContent
            message={
              'Apenas o campo de Local é obrigatório, os outros campos serão preenchidos automaticamente após submissão. Se pretender definir o local específico indique as coordenadas.'
            }
            color="info"
          />
        </div>
        <Content/>
      </SweetAlert>)
    });
  };

  adicionarAnuncio = () => {
    const {classes} = this.props;
    let anuncio = {
      id_user: null,
      formacao_id: this.state.formacao.id,
      titulo: "",
      conteudo: ""
    };

    let setEditorRef = (ref) => {
      setTimeout(() => {
        ref && ref.focus(0);
      }, 5);
    };

    let editorState = EditorState.createEmpty();

    let editorSetMessage = (es) => {
      anuncio.conteudo = draftToHtml(convertToRaw(es.getCurrentContent()));
    };

    this.setState({
      modal: (<SweetAlert
        style={{width: 820}}
        title={(<div style={{textAlign: "left", marginTop: "-20px"}}>
          <span className={classes.modalCardTitle}>Novo Anúncio</span>
        </div>)}
        onConfirm={() => {
          if (anuncio.titulo !== "") {
            connection.post("formacao/post/novo", anuncio, (data) => {
              general.success("Anúncio criado com sucesso.", "Sucesso!");
              this.reloadPostsFormacao();
            });
          } else {
            general.error("Por favor preencha todos os campos obrigatórios.", "Erro!");
          }
        }}
        onCancel={() => this.hideModal()}
        cancelBtnText="Cancelar"
        showCancel
        confirmBtnText="Publicar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <form autoComplete="off" className={classes.addForm}>
          <CustomInput
            labelText="Título*"
            id="novaMensagem-assunto"
            formControlProps={{
              fullWidth: true
            }}
            inputProps={{
              type: "text",
              name: "assunto",
              defaultValue: anuncio.titulo,
              onChange: (e) => {
                anuncio.titulo = e.target.value;
              }
            }}
          />
          <div style={{
            background: "#fbfbfb",
            padding: 5,
            borderRadius: 5,
            marginTop: 5
          }}>
            <Editor
              defaultEditorState={editorState}
              wrapperClassName="wrapper-class"
              editorClassName={"editor-class " + classes.anuncioEditor}
              toolbarClassName={"toolbar-class"}
              onEditorStateChange={(es) => {
                editorState = es;
                editorSetMessage(es);
              }}
              toolbar={{
                options: ["inline", "blockType", "fontSize", "fontFamily", "list", "textAlign", "colorPicker", "link", "remove", "history"]
              }}
              editorRef={setEditorRef}
            />
          </div>
        </form>
      </SweetAlert>)
    });
  };

  apagarAnuncio = (post) => {
    this.setState({
      modal: (
        <SweetAlert
          warning
          title="Apagar Anúncio"
          onConfirm={async () => {
            await connection.post("formacao/post/apagar", {
              formacao: this.state.formacao.id,
              post: post.id
            });
            this.reloadPostsFormacao();
          }}
          onCancel={() => this.hideModal()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          cancelBtnCssClass={
            this.props.classes.button
          }
          confirmBtnText="Apagar"
          cancelBtnText="Cancelar"
          showCancel
        >
          Tem a certeza que pretende apagar o anúncio com o título '{post.titulo}'?
        </SweetAlert>
      )
    });

  };

  avancarEstado = async () => {
    const {classes} = this.props;
    const formacao = this.state.formacao;

    this.setState({
      modal: <SweetAlert
        warning
        title={"Avançar estado"}
        onConfirm={async () => {
          await connection.post("formacao/avancar_estado", {formacao: formacao.id});
          window.App.hideModal();
          this.hideModal();
          this.props.reloadDetalhes();
          this.reloadParticipantesFormacao();
          general.success("Estado alterado com sucesso.");
        }}
        onCancel={() => this.hideModal()}
        confirmBtnText={"Confirmar"}
        showCancel
        cancelBtnText="Cancelar"
        confirmBtnCssClass={
          classes.button + " " + classes.primary + " " + classes.buttonConfirm
        }
        cancelBtnCssClass={
          classes.button
        }
      >
        <p style={{marginTop: 5}}>Para efeitos de demonstração, é possível avançar o estado do módulo em questão. Pretende alterar o estado para <strong>{formacao.estado?.proximo?.designation}</strong>?</p>
      </SweetAlert>
    });
  }

  render() {
    const {classes, location} = this.props;
    const {formacao} = this.state;
    const num_inscritos = this.state.participantes.candidatos?.length + this.state.participantes.participantes?.length;

    return this.state.formacao ? (<div className={classes.cursosContainer}>
      {fases(formacao)}
      {this.state.modal}
      <GridContainer>
        <GridItem xs={12} sm={5}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}><StateCircle state={formacao.estado}/>Módulo #{(formacao.acontecimento_teste ? 'T.' : '') + general.pad(formacao.id, 5)}</h4>
                {formacao.pode_gerir_detalhes && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={this.editDetalhesFormacao}>
                  <Create/> Editar
                </Button>}
              </div>
            </CardHeader>
            <CardBody className={classes.courseDetails}>
              <table>
                <tr>
                  <td>Módulo:</td>
                  <td>{formacao.modulo.codigo + " | " + formacao.modulo.designacao}</td>
                </tr>
                {formacao.curso && <tr>
                  <td>Curso:</td>
                  <td><span className="clickable" onClick={() => {
                    window.App.hist.push("/curso/" + formacao.curso.id);
                  }}>{formacao.curso.descricao}</span></td>
                </tr>}
                <tr>
                  <td>Formador:</td>
                  <td>{general.Renderers.userRenderer(formacao.formador)}</td>
                </tr>
                <tr>
                  <td>Região:</td>
                  <td>{formacao.regiao || '-'}{formacao.apenas_regiao ? " (registos limitados à região)" : ""}</td>
                </tr>
                <tr>
                  <td>Núcleo:</td>
                  <td>{formacao.nucleo || '-'}</td>
                </tr>
                <tr>
                  <td>Agrupamento:</td>
                  <td>{formacao.agrupamento || '-'}</td>
                </tr>
              </table>
            </CardBody>
          </Card>
          <EquipaFormacao acontecimento={this.state.formacao}/>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>Anúncios</h4>
                {formacao.pode_gerir && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.primary} onClick={this.adicionarAnuncio}>
                  <Add/> Novo anúncio
                </Button>}
              </div>
            </CardHeader>
            <CardBody style={{paddingLeft: 0, paddingRight: 0}}>
              {this.state.posts && this.state.posts.length > 0 ? <Table
                striped
                tableHeaderColor="primary"
                tableData={this.state.posts.map((post) => {
                  return [
                    <div style={{paddingLeft: 10, paddingRight: 10}}>
                      <p style={{marginBottom: 15, marginRight: 22}}><strong>{post.titulo}</strong></p>
                      {Parser(post.conteudo.trim().split("\n").join("<br/>"))}
                      <p style={{textAlign: "right", margin: 0, fontSize: 12}}><MomentFromNow time={post.data}/></p>
                      {formacao.pode_gerir && <Button
                        justIcon
                        round
                        simple
                        style={{
                          margin: 0,
                          position: "absolute",
                          top: 3,
                          right: 0
                        }}
                        onClick={() => {
                          this.apagarAnuncio(post);
                        }}
                        color="danger"
                        className="edit"
                      >
                        <FontAwesomeIcon icon={faTrashAlt}/>
                      </Button>}
                    </div>
                  ];
                })}
              /> : <p style={{margin: "20px 20px", textAlign: "center"}}>Clique em 'Novo Anúncio' para criar a sua primeira publicação</p>}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12} sm={7}>
          <Card>
            <CardHeader color="primary">
              <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <h4 style={{flex: 1}}>Gestão de módulo</h4>
                {formacao.pode_gerir && <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={this.editPropriedadesFormacao}>
                  <Create/> Editar
                </Button>}
              </div>
            </CardHeader>
            <CardBody className={classes.courseDetails}>
              <table>
                <tr>
                  <td>Modalidade:</td>
                  <td>{formacao.modalidade_designacao}</td>
                </tr>
                {!formacao.curso && <>
                  <tr>
                    <td>Vagas:</td>
                    <td>{formacao.vagas ? (formacao.vagas + " (" + (formacao.vagas - formacao.selecionados) + " restantes)") : "Por definir"}</td>
                  </tr>
                  {formacao.limite_inscricoes && this.state.formacao.estado.code < general.estadosAcontecimento.REGISTOS_FINALIZADOS && <tr>
                    <td>Limite de inscrições:</td>
                    <td>{formacao.limite_inscricoes ? (formacao.limite_inscricoes + " (" + (formacao.limite_inscricoes - num_inscritos) + " restantes)") : null}</td>
                  </tr>}
                  <tr>
                    <td>Preço:</td>
                    <td>{formacao.preco_disp}</td>
                  </tr>
                  <tr>
                    <td>Início dos registos:</td>
                    <td>{general.Renderers.dateRenderer(formacao.data_abertura_registos)}</td>
                  </tr>
                  <tr>
                    <td>Limite de registos:</td>
                    <td>{general.Renderers.dateRenderer(formacao.data_limite_registos)}</td>
                  </tr>
                </>}
                <tr>
                  <td>Início do módulo</td>
                  <td>{general.Renderers.dateRenderer(formacao.data_inicio)}</td>
                </tr>
                <tr>
                  <td>Fim do módulo</td>
                  <td>{general.Renderers.dateRenderer(formacao.data_fim)}</td>
                </tr>
              </table>
              <hr style={{margin: "10px -20px 6px"}}/>
              <Accordion
                collapses={[
                  {
                    title: "Localização",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.editLocalFormacao();
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: formacao.local ? <React.Fragment>
                      <p style={{textAlign: "center", fontSize: 16}}>{formacao.local}</p>
                      <FormacaoMap
                        googleMapURL={"https://maps.googleapis.com/maps/api/js?key=" + process.env.MAPS_KEY + "&basemap=roadmap"}
                        loadingElement={<div style={{height: `100%`}}/>}
                        lat={this.state.formacao.lat}
                        lon={this.state.formacao.lon}
                        containerElement={
                          <div
                            style={{
                              height: "288px",
                              borderRadius: "6px",
                              overflow: "hidden"
                            }}
                          />
                        }
                        mapElement={<div style={{height: `100%`}}/>}
                      />
                    </React.Fragment> : 'Clique no botão de editar para definir o local'
                  }, {
                    title: "Outros detalhes",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.promptModal("outros detalhes", "Poderá especificar informações adicionais que os participantes poderão ver na página de formação:", formacao.descricao_longa, async (valor) => {
                          await connection.post("formacao/editar_detalhes_extra", {
                            formacao: this.state.formacao.id,
                            detalhes: valor
                          });
                          this.hideModal();
                          this.props.reloadDetalhes();
                          general.success("Outros detalhes editados", "Sucesso");
                        });
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: <React.Fragment>
                      <p>{(formacao.descricao_longa || 'Clique no botão de editar para escrever as informações adicionais').split('\n').map((item, key) => {
                        return <React.Fragment key={key}>{item}<br/></React.Fragment>
                      })}</p>
                    </React.Fragment>
                  }, {
                    title: "Observações",
                    actions: <Button
                      justIcon
                      round
                      simple
                      onClick={(e) => {
                        e.stopPropagation();
                        this.promptModal("Observações", "Defina de seguida as observações que deverão constar no relatório de formacao:", formacao.observacoes, async (valor) => {
                          await connection.post("formacao/editar_observacoes", {
                            formacao: this.state.formacao.id,
                            observacoes: valor
                          });
                          this.hideModal();
                          this.props.reloadDetalhes();
                          general.success("Observações editadas", "Sucesso");
                        });
                      }}
                      className={classes.editObservacoesButton}
                    >
                      <Create/>
                    </Button>,
                    content: <React.Fragment>
                      <p>{(formacao.observacoes || 'Clique no botão de editar para preencher as observações').split('\n').map((item, key) => {
                        return <React.Fragment key={key}>{item}<br/></React.Fragment>
                      })}</p>
                    </React.Fragment>
                  }
                ]}
              />
              {formacao.pode_gerir && <div className={classes.formacaoButtons}>
                {!formacao.data_submissao && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.ativarFormacao}>{formacao.curso ? <>Publicar Módulo</> : <>Submeter Módulo</>}</Button>}
                {formacao.data_submissao && !formacao.data_ativacao && general.userHasPermission("formacao.aprovar") && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.aprovarFormacao}>Aprovar/Publicar Módulo</Button>}
                {formacao.estado?.can_advance && <Button className={classes.button + " " + classes.primary + " " + classes.sm} size="sm" onClick={this.avancarEstado}>Avançar estado</Button>}
                {formacao.pode_gerir && formacao.pode_integrar_moodle && <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={() => this.gerirMoodle()}><FontAwesomeIcon icon={faGraduationCap}/> Moodle</Button>}
                {/*<Button className={classes.button + " " + classes.warning + " " + classes.sm} size="sm" onClick={() => {
                }}>Fechar Formacao</Button>
                <Button className={classes.button + " " + classes.info + " " + classes.sm} size="sm" onClick={() => {
                  let url = "reports/relatorio_formacao?id_formacao=" + formacao.id;
                  general.openReport(url);
                }}>Descarregar Relatório</Button>*/}
              </div>}
            </CardBody>
          </Card>
        </GridItem>
        <GridItem xs={12}>
          {(() => {
            let slides = [
              {
                tabButton: "Participantes",
                tabIcon: Person,
                tabContent: (() => {
                  let cards = [
                    <this.CardParticipantes/>
                  ];
                  if (!this.state.formacao.curso)
                    cards.unshift(<this.CardCandidatos/>);
                  if (this.state.formacao.data_registos_fechados)
                    cards.reverse();
                  return cards;
                })()
              }
            ];
            if (this.state.formacao.estado.code >= general.estadosAcontecimento.FINALIZADO && this.state.participantes_avaliar && this.state.participantes_avaliar.length > 0)
              slides.unshift({
                tabButton: "Presenças/Avaliação",
                tabIcon: List,
                tabContent: <this.CardAvaliacao/>
              });
            if (this.state.formacao.feedback)
              slides.push({
                tabButton: "Feedback",
                tabIcon: RateReview,
                tabContent: <this.CardFeedback/>
              });
            slides.push({
              tabButton: "Anexos",
              tabIcon: Attachment,
              tabContent: <AnexoAcontecimento id_acontecimento={this.state.formacao.acontecimento} setModal={m => this.setState({modal: m})}/>
            })
            if (slides.length > 1)
              return <NavPills
                color="primary"
                alignCenter
                tabs={slides}/>;
            return slides[0].tabContent;
          })()}
        </GridItem>
      </GridContainer>
    </div>) : (<span>Loading..</span>);
  }

  ativarFormacao = async () => {
    const {classes} = this.props;
    const formacao = this.state.formacao;

    let error = null;
    try {
      await connection.get("formacao/validar_informacoes", {formacao: formacao.id}, null, null, {disableNotif: true, returnError: true});
    } catch (e) {
      error = e.message;
    }

    window.App.openModal(<SweetAlert
      warning
      title={!formacao.curso ? <>Submeter Módulo</> : <>Publicar Módulo</>}
      onConfirm={async () => {
        await connection.post("formacao/ativar", {formacao: formacao.id});
        window.App.hideModal();
        this.props.reloadDetalhes();
        general.success("Módulo publicado com sucesso.");
      }}
      onCancel={() => window.App.hideModal()}
      confirmBtnText={!formacao.curso ? "Submeter" : "Publicar"}
      showCancel
      cancelBtnText="Cancelar"
      confirmBtnCssClass={
        classes.button + " " + classes.primary + " " + classes.buttonConfirm
      }
      cancelBtnCssClass={
        classes.button
      }
    >
      {error && <SnackbarContent
        message={error}
        color="warning"
      />}
      <p style={{marginTop: 10}}>Tem a certeza que pretende {!formacao.curso ? "submeter" : "publicar"} o módulo em questão? Não poderá alterar a região, agrupamento e núcleo depois de o fazer e as modificações nas datas serão limitadas. As vagas não poderão ser reduzidas. {!formacao.curso && <strong>O módulo ficará disponível para o público após revisão e aprovação.</strong>}</p>
      <p className={classes.courseDetails}>Informações do módulo:
        <table>
          <tr>
            <td>Modalidade:</td>
            <td>{formacao.modalidade_designacao}</td>
          </tr>
          <tr>
            <td>Região*:</td>
            <td>{formacao.regiao || '-'}</td>
          </tr>
          <tr>
            <td>Núcleo*:</td>
            <td>{formacao.nucleo || '-'}</td>
          </tr>
          <tr>
            <td>Agrupamento*:</td>
            <td>{formacao.agrupamento || '-'}</td>
          </tr>
          <tr>
            <td>Vagas:</td>
            <td>{formacao.vagas || "Por definir"}</td>
          </tr>
          <tr>
            <td>Preço:</td>
            <td>{formacao.preco_disp}</td>
          </tr>
          <tr>
            <td>Início dos registos:</td>
            <td>{general.Renderers.dateRenderer(formacao.data_abertura_registos)}</td>
          </tr>
          <tr>
            <td>Limite de registos:</td>
            <td>{general.Renderers.dateRenderer(formacao.data_limite_registos)}</td>
          </tr>
          <tr>
            <td>Início do módulo</td>
            <td>{general.Renderers.dateRenderer(formacao.data_inicio)}</td>
          </tr>
          <tr>
            <td>Fim do módulo</td>
            <td>{general.Renderers.dateRenderer(formacao.data_fim)}</td>
          </tr>
        </table>
        <small>* não poderão ser modificados após publicação</small>
      </p>
    </SweetAlert>);
  };

  aprovarFormacao = async () => {
    const {classes} = this.props;
    const formacao = this.state.formacao;

    this.setState({
      modal: <SweetAlert
        showClose
        style_options={{position: 'absolute', top: '-130px'}}
        warning
        title={"Aprovar/Publicar Módulo"}
        onCancel={() => this.hideModal()}
        confirmBtnText={<>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.danger + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={async () => {
            await connection.post("formacao/rejeitar_submissao", {formacao: formacao.id});
            window.App.hideModal();
            this.hideModal();
            this.props.reloadDetalhes();
            general.success("Submissão rejeitada com sucesso.");
          }}>Rejeitar
          </button>
          <button className={"btn btn-lg btn-prclassName " + classes.button + " " + classes.primary + " " + classes.buttonConfirm} type="button" style={{marginRight: 8}} onClick={async () => {
            await connection.post("formacao/aprovar", {formacao: formacao.id});
            window.App.hideModal();
            this.hideModal();
            this.props.reloadDetalhes();
            general.success("Formação publicada com sucesso.");
          }}>Publicar
          </button>
        </>}
        confirmBtnStyle={{appearance: "none", border: "none", background: "none", padding: 0}}
      >
        <p style={{marginTop: 10}}>Tem a certeza que pretende publicar o módulo em questão? O módulo ficará imediatamente disponível para o público.</p>
      </SweetAlert>
    });
  }

  CardCandidatos = () => {
    const [filter, setFilter] = useState("");
    const {classes} = this.props;
    const acontecimento = this.state.formacao;
    const num_candidatos = this.state.participantes.candidatos?.length;

    let info_registos = '';
    if (this.state.formacao.estado.code >= general.estadosAcontecimento.REGISTOS_ABERTOS)
      info_registos = " (registos a decorrer)";
    if (this.state.formacao.estado.code >= general.estadosAcontecimento.REGISTOS_FECHADOS)
      info_registos = " (registos fechados)";
    if (this.state.formacao.estado.code >= general.estadosAcontecimento.REGISTOS_FINALIZADOS)
      info_registos = " (registos finalizados)";

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>{this.state.participantes.candidatos?.length === 1 ? 'Candidato' : 'Candidatos'} {num_candidatos > 0 ? `(${num_candidatos}) ` : null}{info_registos ? <><br/><small>{info_registos}</small></> : null}</h4>
          <CustomInput
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setFilter(e.target.value);
              }
            }}
          />
          {acontecimento.pode_gerir && this.state.formacao.estado.code >= general.estadosAcontecimento.PUBLICO && this.state.formacao.estado.code < general.estadosAcontecimento.REGISTOS_FINALIZADOS && <React.Fragment>
            <BotaoOpcoes
              disabled={acontecimento.limite_inscricoes && (acontecimento.inscritos >= acontecimento.limite_inscricoes)}
              className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
              opcoes={[
                {texto: "Apenas um", onClick: () => this.inscreverFormando()},
                general.userHasType("admin", "secretario_regional") && {texto: "Importar Excel", onClick: () => this.importarFormandosExcel()}
              ]}>
              <Add/> Adicionar Candidato
            </BotaoOpcoes>
            {this.state.formacao.estado.code >= general.estadosAcontecimento.REGISTOS_FECHADOS && [
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.danger} onClick={() => {
                window.App.openModal(<SweetAlert
                  warning
                  title={"Finalizar Registos"}
                  onConfirm={async () => {
                    window.App.hideModal();
                    await connection.post("formacao/participantes/finalizar_registos", {id_formacao: this.state.formacao.id});
                    this.props.reloadDetalhes();
                    general.success("Registos finalizados com sucesso.");
                  }}
                  onCancel={() => window.App.hideModal()}
                  confirmBtnText="Finalizar"
                  showCancel
                  cancelBtnText="Cancelar"
                  confirmBtnCssClass={
                    classes.button + " " + classes.primary + " " + classes.buttonConfirm
                  }
                  cancelBtnCssClass={
                    classes.button
                  }
                >
                  Tem a certeza que pretende finalizar os registos? Não será possível adicionar ou aprovar candidatos e os candidatos que não foram aprovados irão ser notificados de que o seu registo não foi aceite. <strong>Esta ação é irreversível</strong>.
                </SweetAlert>);
              }}>
                <Close/> Finalizar Registos
              </Button>,
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.warning} onClick={() => {
                window.App.openModal(<SweetAlert
                  warning
                  title={"Validar Candidatos"}
                  onConfirm={async () => {
                    window.App.hideModal();
                    let apurados = this.state.participantes.candidatos.filter((a) => a.apurado).map((a) => a.id);
                    await connection.post("formacao/participantes/aprovar_apurados", {id_formacao: this.state.formacao.id, apurados: apurados});
                    this.reloadParticipantesFormacao();
                    general.success("Candidatos apurados aprovados com sucesso");
                  }}
                  onCancel={() => window.App.hideModal()}
                  confirmBtnText="Validar"
                  showCancel
                  cancelBtnText="Cancelar"
                  confirmBtnCssClass={
                    classes.button + " " + classes.primary + " " + classes.buttonConfirm
                  }
                  cancelBtnCssClass={
                    classes.button
                  }
                >
                  Tem a certeza que pretende validar os candidatos apurados? Os candidatos apurados serão notificados e serão emitidos os pedidos de pagamento (caso aplicável).
                </SweetAlert>);
              }}>
                <Check/> Validar apurados
              </Button>,
              <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} onClick={async () => {
                await connection.post("formacao/participantes/calcular_apurados", {id_formacao: this.state.formacao.id});
                this.reloadParticipantesFormacao();
                general.success("Candidatos recalculados com sucesso");
              }}>
                <Refresh style={{margin: 0}}/>
              </Button>
            ]}
          </React.Fragment>}
          {this.state.participantes.candidatos?.length > 0 && <a className={classes.addStuffButton + " " + classes.button + " " + classes.info}
                                                                 target={'_blank'}
                                                                 href={Connection.getFullUrl("formacao/participantes/listagem", {id_formacao: this.state.formacao.id, exportar_candidatos: true})}>
            <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
          </a>}
        </div>
      </CardHeader>
      <ReactTable
        placeholder={["Nesta área serão apresentados os candidatos ao módulo.", <br/>, "Verifique que publicou o módulo para que os candidatos se possam inscrever."]}
        data={general.filterTable(this.state.participantes.candidatos, filter)}
        minRows={1}
        SubComponent={(row) => <UserDetailsBox detalhes_formacao={this.state.formacao} {...row.original} dataUrl={`formacao/participantes/detalhes?id_formacao=${this.state.formacao.id}&id=${row.original.id}`} reloadData={this.reloadParticipantesFormacao}/>}
        columns={[
          {
            Header: "Nome",
            accessor: "nome",
            Cell: (row) => {
              return <span>
                  <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                    window.App.hist.push("/perfil/" + row.original.id);
                  }}> <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                  </a> {row.original.apurado && <Tooltip
                title="Apurado"
                placement="top"
                classes={{tooltip: classes.tooltip}}
              >
                <span><FontAwesomeIcon style={{color: "#16924a", height: "auto"}} icon={faCheckCircle}/></span>
              </Tooltip>}
                {row.original.preco > 0 && row.original.data_selecao && <Tooltip
                  title="A aguardar pagamento"
                  placement="top"
                  classes={{tooltip: classes.tooltip}}
                >
                  <span><FontAwesomeIcon style={{color: "#FFC107", height: "auto", marginLeft: "3px"}} icon={faCoins}/></span>
                </Tooltip>}</span>;
            }
          },
          {
            Header: "Data de inscrição",
            accessor: "data_registo",
            Cell: general.Renderers.dateRenderer
          },
          {
            Header: "Pontos",
            id: "cursoCandiatoPrioridade",
            accessor: (d) => d.prioridade_inscricao !== null ? d.prioridade_inscricao : ' - ',
            width: 100
          },
          {
            Header: "Estado",
            Cell: (row) => <RegistrationState {...row.original.estado_registo}/>,
            width: 150,
            getProps: () => {
              return {
                style: {
                  textAlign: "center"
                },
              };
            }
          }
        ]}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  }

  CardParticipantes = () => {
    const [filter, setFilter] = useState("");
    const {classes} = this.props;
    const num_participantes = this.state.participantes.participantes?.length;

    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>{this.state.participantes.participantes?.length === 1 ? 'Participante' : 'Participantes'} {num_participantes > 0 ? `(${num_participantes})` : null}</h4>
          <CustomInput
            formControlProps={{
              className: classes.searchInput
            }}
            inputProps={{
              type: "text",
              placeholder: "Pesquisar",
              onChange: (e) => {
                setFilter(e.target.value);
              }
            }}
          />
          {this.state.participantes.participantes?.length > 0 && <BotaoOpcoes
            className={classes.addStuffButton + " " + classes.button + " " + classes.info}
            opcoes={[
              {
                texto: "Listagem simples",
                onClick: () => window.open(Connection.getFullUrl("formacao/participantes/listagem", {id_formacao: this.state.formacao.id, exportar_participantes: true}))
              },
              general.userHasType("admin") && {
                texto: "Modelo Moodle",
                onClick: () => window.open(Connection.getFullUrl("formacao/participantes/listagem", {id_formacao: this.state.formacao.id, exportar_participantes: true, modelo_moodle: true}))
              }
            ]}>
            <FontAwesomeIcon icon={faFileExcel}/> Exportar Listagem
          </BotaoOpcoes>}
          {(this.state.formacao.pode_gerir
            && general.userHasPermission("formacao.inscrever_recurso")
            && this.state.formacao.estado.code >= general.estadosAcontecimento.REGISTOS_FINALIZADOS && this.state.formacao.estado.code < general.estadosAcontecimento.A_DECORRER
            && this.state.formacao.vagas_livres > 0
            || general.userHasType("admin")
            && this.state.formacao.estado.code >= general.estadosAcontecimento.A_DECORRER && this.state.formacao.estado.code < general.estadosAcontecimento.FECHADO) && <BotaoOpcoes
            className={classes.addStuffButton + " " + classes.button + " " + classes.primary}
            opcoes={[
              {texto: "Apenas um", onClick: () => this.inscreverFormando(true)},
              general.userHasType("admin", "secretario_regional") && {texto: "Importar Excel", onClick: () => this.importarFormandosExcel(true)}
            ]}>
            <Add/> Adicionar Participante
          </BotaoOpcoes>}
        </div>
      </CardHeader>
      <ReactTable
        placeholder={"Este módulo ainda não tem participantes"}
        data={general.filterTable(this.state.participantes.participantes, filter)}
        minRows={1}
        SubComponent={(row) => <UserDetailsBox detalhes_formacao={this.state.formacao} {...row.original} dataUrl={`formacao/participantes/detalhes?id_formacao=${this.state.formacao.id}&id=${row.original.id}`} reloadData={this.reloadParticipantesFormacao}/>}
        columns={[
          {
            Header: "Nome",
            accessor: "nome",
            Cell: (row) => {
              return (
                <span>
                  {row.original.acoes_utilizador && row.original.acoes_utilizador.length > 0 && row.original.acoes_utilizador.find((a) => !a.optional === true) && <Tooltip
                    title={"Existem ações pendentes, expanda para ver mais"}
                    placement="top"
                  ><span><FontAwesomeIcon icon={faExclamationTriangle} color={"#fd9729"}/> </span></Tooltip>}
                  <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                    window.App.hist.push("/perfil/" + row.original.id);
                  }}> <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <FontAwesomeIcon icon={faSearchPlus} style={{cursor: "pointer", marginLeft: "5px", color: "grey"}}/></a>
                </span>
              );
            }
          },
          {
            Header: "Registo aprovado",
            accessor: "data_aprovacao",
            Cell: general.Renderers.dateRenderer
          },
          {
            Header: "Estado",
            Cell: (row) => <StateCircle state={row.original.estado_registo} detailed/>
          }
        ]}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
    </Card>
  };

  CardAvaliacao = () => {
    const {classes} = this.props;
    const nota_minima_aprovacao = ['EMSPIF', 'EMS'].includes(this.state.formacao.modulo.tipo_curso) ? 85 : 50;
    const desvio_seta_nota = 0.22; // acerto fino da seta do popover: fração da largura, para a direita
    const [avaliacaoParticipantes, setAvaliacaoParticipantes] = useState(this.state.participantes_avaliar.reduce((a, b) => {
      a[b.id] = {
        ...b,
        presente: true,
        avaliacao: 100,
        avaliacaoInput: "",
        editarAvaliacao: false,
        setaNota: "50%"
      };

      return a;
    }, {}));
    const chipsAvaliacao = React.useRef({});
    const ordemLinhas = React.useRef({});

    let updateAvaliacao = function (id, info) {
      setAvaliacaoParticipantes(anterior => ({
        ...anterior,
        [id]: {
          ...anterior[id],
          ...info
        }
      }))
    }

    // nota escrita à mão: vazio mantém o valor por omissão (placeholder), o resto é limitado a 0-100
    let comitarNota = function (input) {
      if (input === "")
        return {};

      let nota = Number(input);
      if (isNaN(nota) || nota < 0)
        nota = 0;
      else if (nota > 100)
        nota = 100;
      else
        nota = Math.round(nota);

      return {avaliacao: nota, avaliacaoInput: String(nota)};
    };

    // A pauta do Moodle serve para preencher a tabela: nada é gravado até "Finalizar avaliação"
    let importarPauta = () => {
      const Modal = () => {
        const [pauta, setPauta] = useState(null);
        const [item, setItem] = useState("");
        const [erro, setErro] = useState(null);
        const [aguardar, setAguardar] = useState(true);

        React.useEffect(() => {
          (async () => {
            try {
              let dados = await connection.get("formacao/moodle/pauta", {formacao: this.state.formacao.id}, null, null, {returnError: true, disableNotif: true});
              setPauta(dados);

              let primeiro = dados.itens.find(i => i.valido);
              if (primeiro)
                setItem(primeiro.id);
            } catch (e) {
              setErro(e.message || "Não foi possível ler a pauta do Moodle.");
            }
            setAguardar(false);
          })();
        }, []);

        let notas = (pauta && pauta.notas[item]) || {};
        let sem_itens = pauta && !pauta.itens.some(i => i.valido);
        let pode_importar = !aguardar && !erro && !sem_itens && !!item;

        // O Moodle não deixa configurar o total do curso por API: a garantia de 0 a 100 é esta
        let aviso = (erro || sem_itens) && <div className={classes.warningLabel} style={{marginTop: 0, marginBottom: sem_itens ? 25 : 10, padding: "15px 15px"}}>
          <span><FontAwesomeIcon icon={faExclamationTriangle}/> {erro
            || "Nenhum item da pauta está configurado de 0 a 100. Configure no Moodle a nota máxima do item que quer importar e volte a tentar."}</span>
        </div>;

        return <SweetAlert
          style={{width: 600}}
          title={<div style={{textAlign: "left", marginTop: "-20px"}}>
            <span className={classes.modalCardTitle}>Importar pauta do Moodle</span>
          </div>}
          onConfirm={() => {
            if (!pode_importar)
              return;

            // Quem não traz nota da pauta fica marcado como ausente: sem nota não há presença
            setAvaliacaoParticipantes(anterior => {
              let novo = {...anterior};

              Object.values(anterior).forEach(participante => {
                let nota = notas[participante.nin];
                novo[participante.id] = nota !== undefined
                  ? {...participante, presente: true, avaliacao: nota, avaliacaoInput: String(nota)}
                  : {...participante, presente: false};
              });

              return novo;
            });

            this.hideModal();
            general.success("Notas preenchidas com informações do Moodle");
          }}
          onCancel={() => this.hideModal()}
          confirmBtnText={aguardar ? <><FontAwesomeIcon icon={faSpinner} spin/> A ler pauta...</> : "Preencher notas"}
          showCancel
          cancelBtnText="Cancelar"
          confirmBtnCssClass={classes.button + " " + classes.primary + " " + classes.buttonConfirmLargo + (pode_importar ? "" : " " + classes.disabled)}
          cancelBtnCssClass={classes.button}
        >
          <div className={classes.addForm}>
            {aviso}
            {aguardar && <p style={{margin: "20px 0", textAlign: "center"}}>
              <FontAwesomeIcon icon={faSpinner} spin/> A ler a pauta do Moodle...
            </p>}
            {pauta?.disciplina?.curso && <p style={{margin: "0 0 10px 0"}}>
              <small>A pauta é a da disciplina do curso <strong>{pauta.disciplina.curso}</strong>, que tem os itens
                de todos os módulos: escolha o que corresponde a este.</small>
            </p>}
            {pauta && !sem_itens && <FormControl fullWidth className={classes.selectFormControl} style={{marginBottom: 20}}>
              <InputLabel className={classes.selectLabel}>Item da pauta</InputLabel>
              <Select MenuProps={{className: classes.selectMenu}} classes={{select: classes.select}}
                      value={item} onChange={e => setItem(e.target.value)}>
                {pauta.itens.map(i => <MenuItem key={i.id} value={i.id} disabled={!i.valido}
                                                classes={{root: classes.selectMenuItem, selected: classes.selectMenuItemSelected}}>
                  {i.nome} <span style={{marginLeft: 6, color: i.valido ? undefined : warningColor}}>({i.grademin} a {i.grademax})</span>
                </MenuItem>)}
              </Select>
            </FormControl>}

            {pauta && <div style={{maxHeight: "calc(100vh - 460px)", minHeight: 100, marginTop: 15, overflow: "auto"}}>
              <MaterialTable className={classes.table} size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>NIN</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell align="right">Presente</TableCell>
                    <TableCell align="right">Nota</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.values(avaliacaoParticipantes).map(participante => {
                    let nota = notas[participante.nin];
                    let motivo = pauta && !pauta.inscritos.includes(participante.nin)
                      ? "Não está inscrito no Moodle" : "Sem nota neste item";

                    return <TableRow key={participante.id}>
                      <TableCell component="th" scope="row">{participante.nin}</TableCell>
                      <TableCell>{participante.nome}</TableCell>
                      <TableCell align="right">{nota !== undefined ? "Sim" : <span style={{color: warningColor}}>Não</span>}</TableCell>
                      <TableCell align="right">{nota !== undefined ? nota : <span style={{color: warningColor}}>{motivo}</span>}</TableCell>
                    </TableRow>;
                  })}
                </TableBody>
              </MaterialTable>
            </div>}
          </div>
        </SweetAlert>;
      };

      this.setState({modal: <Modal/>});
    };

    let finalizarAvaliacao = async () => {
      this.setState({
        modal: <SweetAlert
          style={{width: 600}}
          warning
          title={"Finalizar avaliação"}
          onConfirm={async () => {
            try {
              await connection.post("formacao/participante/avaliar_varios", {
                formacao: this.state.formacao.id,
                avaliacoes: Object.values(avaliacaoParticipantes).map(a => ({
                  formando: a.id,
                  presente: a.presente,
                  avaliacao: a.presente ? a.avaliacao : undefined
                }))
              }, null, null, {returnError: true});
            } catch (e) {
              // Sem isto o erro rejeitava a promessa em silêncio: o popup ficava aberto sem dizer nada
              return general.error(e.message || "Não foi possível submeter a avaliação.", "Erro!");
            }

            this.hideModal();
            this.reloadParticipantesFormacao()
            general.success("Avaliação finalizada com sucesso");
          }}
          onCancel={() => this.hideModal()}
          confirmBtnText={"Confirmar"}
          showCancel
          cancelBtnText="Cancelar"
          confirmBtnCssClass={
            classes.button + " " + classes.primary + " " + classes.buttonConfirm
          }
          cancelBtnCssClass={
            classes.button
          }
        >
          <p style={{marginTop: 10}}>Confirma a submissão das presenças e avaliação dos formandos?</p>
          <MaterialTable className={classes.table} size="small">
            <TableHead>
              <TableRow>
                <TableCell>NIN</TableCell>
                <TableCell>Nome</TableCell>
                <TableCell align="right">Presente</TableCell>
                <TableCell align="right">Avaliação</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.values(avaliacaoParticipantes).map((row) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.nin}
                  </TableCell>
                  <TableCell>{row.nome}</TableCell>
                  <TableCell align="right">{row.presente ? "Sim" : <span style={{color: warningColor}}>Não</span>}</TableCell>
                  <TableCell align="right">{row.presente ? (row.avaliacao >= nota_minima_aprovacao ? row.avaliacao : <span style={{color: warningColor}}>{row.avaliacao}</span>) : "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </MaterialTable>
        </SweetAlert>
      });
    }

    return <Card className={classes.cardAvaliacao}>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Avaliar participantes</h4>
          {(this.state.formacao.id_moodle || this.state.formacao.curso?.id_moodle) &&
            <Button className={classes.addStuffButton + " " + classes.button + " " + classes.info} size="sm" onClick={importarPauta}>
              <FontAwesomeIcon icon={faGraduationCap}/> Importar Moodle
            </Button>}
        </div>
      </CardHeader>
      <ReactTable
        placeholder={"Este módulo ainda não tem participantes"}
        data={Object.values(avaliacaoParticipantes)}
        minRows={1}
        columns={[
          {
            Header: "NIN",
            accessor: "nin",
            width: 120
          },
          {
            Header: "Nome",
            accessor: "nome",
            Cell: (row) => {
              return (
                <span>
                  <a style={{cursor: "pointer"}} target={"_self"} onClick={() => {
                    window.App.hist.push("/perfil/" + row.original.id);
                  }}> <EstadoUtilizador nome={row.value} estado={row.original.estado}/>
                    <FontAwesomeIcon icon={faSearchPlus} style={{cursor: "pointer", marginLeft: "5px", color: "grey"}}/></a>
                </span>
              );
            }
          },
          {
            Header: "Presença",
            sortable: false,
            width: 120,
            style: {textAlign: "center"},
            headerStyle: {textAlign: "center"},
            Cell: (row) => <Switch
              checked={row.original.presente}
              onChange={(e) => {
                updateAvaliacao(row.original.id, {presente: e.target.checked})
              }}
              color="primary"
            />
          },
          {
            Header: "Avaliação",
            sortable: false,
            width: 150,
            style: {textAlign: "center"},
            headerStyle: {textAlign: "center"},
            Cell: (row) => {
              // ordem visível das linhas (respeita ordenação e paginação), para o salto com Tab
              if (row.viewIndex === 0)
                ordemLinhas.current = {};
              ordemLinhas.current[row.viewIndex] = row.original.id;

              let reprovado = row.original.avaliacao < nota_minima_aprovacao;
              let corNota = reprovado ? warningColor : primaryColor;

              return <>
                <Chip label={row.original.avaliacao}
                      ref={el => chipsAvaliacao.current[row.original.id] = el}
                      disabled={!row.original.presente}
                      color="primary"
                      style={{minWidth: 50, backgroundColor: corNota}}
                      onClick={(e) => updateAvaliacao(row.original.id, {editarAvaliacao: chipsAvaliacao.current[row.original.id] || e.target})}
                />
                <Popover
                  open={!!row.original.editarAvaliacao}
                  anchorEl={row.original.editarAvaliacao}
                  disableScrollLock
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                  }}
                  transformOrigin={{
                    vertical: -10,
                    horizontal: 'center',
                  }}
                  onClose={() => updateAvaliacao(row.original.id, {editarAvaliacao: false})}
                  PaperProps={{style: {overflow: "visible"}}}
                  TransitionProps={{
                    onEntering: (paper) => {
                      let pill = chipsAvaliacao.current[row.original.id];
                      if (!pill)
                        return;

                      let pillRect = pill.getBoundingClientRect();
                      let paperRect = paper.getBoundingClientRect();

                      // o popover pode ser encostado à margem da janela: a seta segue a pill, não o centro do popover
                      // (e desaparece se o popover não tiver ficado por baixo da pill)
                      updateAvaliacao(row.original.id, {
                        setaNota: paperRect.top >= pillRect.bottom - 1
                          ? Math.min(Math.max(pillRect.left + pillRect.width / 2 - paperRect.left + paperRect.width * desvio_seta_nota, 14), paperRect.width - 14)
                          : false
                      });
                    }
                  }}
                >
                  <div style={{
                    width: 260,
                    padding: "11px 20px",
                    paddingBottom: 5,
                    position: "relative"
                  }}>
                    {/* seta a apontar para a pill da nota */}
                    {row.original.setaNota !== false && <div style={{
                      position: "absolute",
                      top: -8,
                      left: row.original.setaNota,
                      marginLeft: -8,
                      width: 0,
                      height: 0,
                      borderLeft: "8px solid transparent",
                      borderRight: "8px solid transparent",
                      borderBottom: "8px solid #fff"
                    }}/>}
                    <p>Alterar nota:</p>
                    <div style={{display: "flex", alignItems: "center"}}>
                      <Slider
                        aria-label="Nota"
                        color="primary"
                        value={row.original.avaliacao}
                        onChange={(e, v) => updateAvaliacao(row.original.id, {avaliacao: v, avaliacaoInput: String(v)})}
                        valueLabelDisplay={"off"}
                        step={10}
                        marks
                        min={0}
                        max={100}
                        className={reprovado ? classes.sliderNotaAviso : classes.sliderNota}
                        style={{flex: 1, color: corNota}}
                      />
                      <TextField
                        autoFocus
                        placeholder={"100"}
                        value={row.original.avaliacaoInput}
                        onChange={(e) => updateAvaliacao(row.original.id, {
                          avaliacaoInput: e.target.value,
                          avaliacao: e.target.value === "" ? 100 : Number(e.target.value)
                        })}
                        onBlur={() => updateAvaliacao(row.original.id, comitarNota(row.original.avaliacaoInput))}
                        onKeyDown={(e) => {
                          if (e.key !== "Enter" && e.key !== "Tab")
                            return;

                          let fechar = {...comitarNota(row.original.avaliacaoInput), editarAvaliacao: false};

                          if (e.key === "Enter") {
                            e.preventDefault();
                            updateAvaliacao(row.original.id, fechar);
                            return;
                          }

                          // Tab (ou Shift+Tab) salta para a nota da linha seguinte/anterior
                          let seguinte = ordemLinhas.current[row.viewIndex + (e.shiftKey ? -1 : 1)];
                          let chip = seguinte !== undefined ? chipsAvaliacao.current[seguinte] : undefined;

                          updateAvaliacao(row.original.id, fechar);

                          if (chip) {
                            e.preventDefault();
                            // scroll síncrono antes de abrir, para o popover ser posicionado já na posição final
                            chip.scrollIntoView({block: "center", inline: "nearest"});
                            updateAvaliacao(seguinte, {editarAvaliacao: chip});
                          }
                        }}
                        type="number"
                        inputProps={{min: 0, max: 100, step: 1, style: {textAlign: "center", padding: "6px 0"}}}
                        style={{width: 55, marginLeft: 15}}
                      />
                    </div>
                  </div>
                </Popover>
              </>;
            }
          }
        ]}
        defaultPageSize={20}
        showPaginationBottom={true}
        className="-striped -highlight"
      />
      <div className={classes.formacaoButtons} style={{marginBottom: 20}}>
        <Button className={classes.button + " " + classes.primary} size="sm" onClick={finalizarAvaliacao}>Finalizar avaliação</Button>
      </div>
    </Card>
  };

  CardFeedback = () => {
    let feedback = this.state.formacao.feedback;

    let submissoes_restantes = this.state.formacao.presentes - feedback.numero_submissoes;
    return <Card>
      <CardHeader color="primary">
        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
          <h4 style={{flex: 1}}>Feedback
            {feedback.estado === "INCOMPLETO" && <> ({(submissoes_restantes === 1 ? "falta " : "faltam ") + submissoes_restantes + (submissoes_restantes === 1 ? " submissão" : " submissões")})</>}
            {feedback.estado === "COMPLETO" && <> ({feedback.numero_submissoes + (feedback.numero_submissoes === 1 ? " submissão" : " submissões")})</>}
          </h4>
        </div>
      </CardHeader>
      {feedback.estado === "ESCONDIDO" ? <CardBody style={{textAlign: "center", padding: "6em 0", color: "#bbbbbb"}}>
          <h5 style={{fontStyle: "italic", fontWeight: "400"}}>Feedback não disponível</h5>
          <p>Ainda não é possível ver o feedback, pois apenas {feedback.numero_submissoes} formandos (de {this.state.formacao.presentes} presentes) fizeram a sua submissão</p>
        </CardBody> :
        <CardBody style={{overflow: "auto"}}>
          {Object.values(feedback.questoes).map(questao => {
            let grafico = {
              labels: Object.values(questao.respostas).map(resposta => general.breakLabel(resposta.pergunta, 40)),
              datasets: [
                {
                  data: Object.values(questao.respostas).map(resposta => resposta.media),
                  backgroundColor: "#009344",
                  barPercentage: 0.6
                }
              ]
            };

            let options = {
              maintainAspectRatio: false,
              scales: {
                yAxes: [{
                  afterFit: function (scaleInstance) {
                    scaleInstance.width = 270;
                  }
                }],
                xAxes: [{
                  ticks: {
                    stepSize: 1,
                    min: Math.min(...questao.escala.map(e => e.valor)),
                    max: Math.max(...questao.escala.map(e => e.valor)),
                    callback: function (val, index) {
                      let nivel = questao.escala?.find(e => e.valor === val);
                      if (!nivel)
                        return '';
                      return nivel.valor + " - " + nivel.designacao;
                    }
                  }
                }]
              },
              legend: {
                display: false
              }
            };

            return <>
              <h4 style={{marginTop: 25}}>{questao.titulo}</h4>
              <div style={{height: 50 * (Object.values(questao.respostas).length + 1), minWidth: 600}}>
                <HorizontalBar data={grafico}
                               options={options}/>
              </div>
            </>
          })}
          {Object.values(feedback.comentarios).map(comentarios => {
            return <>
              <h4 style={{marginTop: 25}}>{comentarios.titulo}</h4>
              <ul>{comentarios.respostas.map(resposta => {
                return <li style={{listStyleType: "disc", marginBottom: "10px", textAlign: "justify"}}>{resposta}</li>
              })}</ul>
            </>
          })}
        </CardBody>}
    </Card>;
  };
}

export default withStyles(formacoesStyle)(GestaoFormacao);
